import { Component, ViewEncapsulation, OnInit, OnDestroy, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


@Component({
    selector: 'mi-selected-approval-type',
    imports: [
        ReactiveFormsModule,
    ],
    templateUrl: './selected-approval-type.html',
    styleUrl: './selected-approval-type.scss',
    encapsulation: ViewEncapsulation.None
})
export class SelectedApprovalTypeComponent implements OnInit, OnDestroy {

    private translateService = inject(TranslateService);

    readonly approvalTypeName = input.required<string>();
    readonly approvalMainTypeName = input.required<string>();
    subscription: Subscription = new Subscription()
    selectedApprovalTypeText: any;



    ngOnInit() {
        this.initText();
    }

    initText() {
        this.subscription.add(this.translateService.stream('approvalTypeMethod.selectedApprovalType').subscribe(translation => {
            this.selectedApprovalTypeText = translation;
        }));
    }

    approvalTypeSelectedFullName = () => {
        const approvalMainTypeName = this.approvalMainTypeName();
        const approvalTypeName = this.approvalTypeName();
        if (approvalMainTypeName == approvalTypeName) {
            return approvalTypeName;
        }
        return `${approvalMainTypeName} - ${approvalTypeName}`
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
